import React from 'react';
import {
  ArrowRight,
  BarChart3,
  Bell,
  Calendar,
  CheckCircle2,
  CreditCard,
  MessageSquare,
  PlayCircle,
  Sparkles,
  Tag,
  TrendingUp,
  sparke,
} from 'lucide-react';

/**
 * Lucide icons for the merchant landing page — matches NOWOffers_WebsiteCode /for-business.
 * Keep lucide-react aligned with the reference (^0.575); Sparkles and other glyphs differ across major versions.
 * Module CSS sets fill:none on paths where sanitize.css would otherwise fill SVGs.
 */
const lucideProps = {
  fill: 'none',
  'aria-hidden': true,
};

const wrapLucide = Icon => {
  const Wrapped = ({ className, size, strokeWidth = 2, ...rest }) => (
    <Icon className={className} size={size} strokeWidth={strokeWidth} {...lucideProps} {...rest} />
  );
  Wrapped.displayName = Icon.displayName || Icon.name;
  return Wrapped;
};

export const ArrowRightIcon = wrapLucide(ArrowRight);
export const BarChart3Icon = wrapLucide(BarChart3);
export const BellIcon = wrapLucide(Bell);
export const CalendarIcon = wrapLucide(Calendar);
export const CheckCircle2Icon = wrapLucide(CheckCircle2);
export const CreditCardIcon = wrapLucide(CreditCard);
export const MessageSquareIcon = wrapLucide(MessageSquare);
export const PlayCircleIcon = wrapLucide(PlayCircle);
export const SparklesIcon = wrapLucide(Sparkles);
export const TagIcon = wrapLucide(Tag);
export const TrendingUpIcon = wrapLucide(TrendingUp);
